module.exports = __webpack_public_path__ + "img/logo_login.e89027cb.png";